import Vue, { PropType } from 'vue';
import { ICalendarDayConfig } from 'js/crossword/calendarData';
import ProgressRing from "../ProgressRing";

import styles from "../css/CalendarDay.module.css";
import OS from "js/framework/utils/OS";

export default Vue.extend({
  props: {
    options: Object as PropType<ICalendarDayConfig>,
    selected: Boolean,
    currentPuzzleId: String,
  },
  computed: {
    progress(): number {
      return this.options.fillRate || 0;
    },
    currentPuzzle(): boolean {
      return this.currentPuzzleId === this.options.puzzleId;
    },
    dayNumberClasses(): string[] {
      const classes = [styles.dayNumber];
      if (!this.options.puzzleUrl) classes.push(styles.dayNumberFadeOut);
      if (this.currentPuzzle) classes.push(styles.dayNumberCurrentDay);
      return classes;
    },
    higlightClasses(): string[] {
      const classes = [styles.highlight];
      if (this.currentPuzzle) {
        classes.push(styles.highlightCurrent);
      } else if (this.selected) {
        classes.push(styles.highlightSelected);
      }
      return classes;
    },
  },
  render() {
    const { currentMonth, dayNumber, puzzleUrl } = this.options;
    if (!currentMonth) return <div class={styles.empty}></div>;

    return (
      <div class={OS.desktop ? styles.container : styles.containerMobile}>
        { this.progress > 0
            ? <ProgressRing
                progress={this.progress}
                class={[styles.circle, styles.highlightCompleted]}
              />
            : null
        }
        <div
          class={{
            [styles.circle]: true,
            [styles.circleActive]: Boolean(puzzleUrl),
            [styles.outerRing]: Boolean(puzzleUrl),
          }}
          onClick={() => this.$emit("dayClicked")}
        > 
          <div class={this.higlightClasses}>
            <div class={this.dayNumberClasses}>{ dayNumber || 0 }</div>
          </div>
        </div>
      </div>
    );
  },
});
